import React from 'react'
import { ProfilePageContent, ProfilePageWrapper } from '../../components/ProfilePageComponents'

export const ProfilePage = () => (
  <ProfilePageWrapper>
    <ProfilePageContent />
  </ProfilePageWrapper>
)
